<template>
  <div class="mb-4">
    <template v-if="mode === 'tentative'">
      <div
        class="d-flex align-center px-1 mb-2"
        style="gap: 8px;">
        <v-icon
          small
          color="#1976D2">
          mdi-progress-clock
        </v-icon>
        <span
          class="text-caption font-weight-bold"
          style="color: #1976D2;">
          สินค้าตัวอย่าง
        </span>
      </div>

      <v-row
        no-gutters
        class="mb-3">
        <v-col
          v-for="(card, i) in tentativeCards"
          :key="`tent-${i}`"
          cols="6"
          md="3">
          <v-card
            outlined
            tile
            class="pa-4"
            :style="i < 3 ? 'border-right: none;' : ''">
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
              height="2"
              class="mb-2" />
            <div class="text-caption grey--text">
              {{ card.label }}
            </div>
            <div
              class="text-h5 font-weight-medium"
              :class="card.colorClass">
              {{ card.value }}
            </div>
            <div class="text-caption grey--text">
              {{ card.sub }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div
        class="d-flex align-center px-1 mb-2"
        style="gap: 8px;">
        <v-icon
          small
          color="#3949AB">
          mdi-factory
        </v-icon>
        <span
          class="text-caption font-weight-bold"
          style="color: #3949AB;">
          สินค้าสำหรับขาย
        </span>
      </div>

      <v-row no-gutters>
        <v-col
          v-for="(card, i) in producingCards"
          :key="`prod-${i}`"
          cols="6"
          md="3">
          <v-card
            outlined
            tile
            class="pa-4"
            :style="i < 3 ? 'border-right: none;' : ''">
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="primary"
              height="2"
              class="mb-2" />
            <div class="text-caption grey--text">
              {{ card.label }}
            </div>
            <div
              class="text-h5 font-weight-medium"
              :class="card.colorClass">
              {{ card.value }}
            </div>
            <div class="text-caption grey--text">
              {{ card.sub }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CapacitySummaryBar',
  props: {
    mode: { type: String, default: 'tentative' },
    summary: { type: Object, default: null },
    loading: { type: Boolean, default: false }
  },
  computed: {
    tentativeCards () {
      return this.buildCards(this.summary ? this.summary.tentative : null)
    },
    producingCards () {
      return this.buildCards(this.summary ? this.summary.producing : null)
    }
  },
  methods: {
    utilizationColor (val) {
      if (val == null) return ''
      if (val <= 60) return 'success--text'
      if (val <= 80) return 'warning--text'
      if (val <= 90) return 'orange--text'
      return 'error--text'
    },
    buildCards (s) {
      const d = s || {}
      return [
        {
          label: 'Total capacity',
          value: d.totalCapacityProduct != null ? d.totalCapacityProduct.toLocaleString() : 0,
          sub: 'products',
          colorClass: ''
        },
        {
          label: 'Allocated',
          value: d.allocatedProduct != null ? d.allocatedProduct.toLocaleString() : 0,
          sub: d.totalCapacityProduct
            ? `${Math.round((d.allocatedProduct / d.totalCapacityProduct) * 100)}% of total`
            : '0% of total',
          colorClass: ''
        },
        {
          label: 'Available',
          value: d.availableProduct != null ? d.availableProduct.toLocaleString() : 0,
          sub: 'products remaining',
          colorClass: ''
        },
        {
          label: 'Avg utilization',
          value: d.averageUtilization != null ? `${Math.round(d.averageUtilization)}%` : '0%',
          sub: 'across all factories',
          colorClass: this.utilizationColor(d.averageUtilization)
        }
      ]
    }
  }
}
</script>
